import {createApp} from 'vue'
import {createPinia} from 'pinia'
import "core-js/stable";
import App from '@/user/App.vue'
import { setupCalendar, DatePicker } from 'v-calendar';
import router from '@/user/router'
import Vue3Sanitize from "vue-3-sanitize";

import '@/shared/global';
import '@/user/global';
import '@/user/assets/scss/main.scss';
import sharedMixin from '@/shared/mixins';
import 'v-calendar/style.css';

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(router);
app.use(Vue3Sanitize, {allowedTags: []});
app.mixin(sharedMixin);
app.use(setupCalendar, {});
app.component('DatePicker', DatePicker);
app.mount('#app');
